import { render, staticRenderFns } from "./DeregisterDelete.vue?vue&type=template&id=68d3027f&"
import script from "./DeregisterDelete.vue?vue&type=script&lang=js&"
export * from "./DeregisterDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports